<!-- Loading bar -->
<app-loader [loading]="loading"></app-loader>

<div class="block-data" [hidden]="loading">
  <!-- View mode -->
  <div *ngIf="!isEditMode">
    <div class="tableColumns">
      <!-- Add new column -->
      <button class="btn btn-rbv" type="button" *ngIf="columns.length < 6" (click)="addColumn()">
        <i class="fa fa-plus"></i>
        Add Column
      </button>

      <!-- New Column -->
      <div *ngIf="isAddColumn" class="d-flex m-l-10 posRelative">
        <input type="text" class="searchInput form-control" placeholder="Census Location"
               [(ngModel)]="columnName" autofocus #inputText/>
        <div class="inputIcon"><i class="fa fa-chevron-down"></i></div>
        <div class="autoCompleteInput"
             [ngClass]="{'d-none': !columnName.length, 'loading-icon-class': showSearchLoading}">
          <div *ngIf="!showSearchLoading">
            <div *ngFor="let item of searchResults" (click)="selectLocation(item)">
              <div class="item">{{item}}</div>
            </div>
          </div>
          <div class="loading-icon-small" *ngIf="showSearchLoading"></div>
        </div>
      </div>

      <!-- Columns -->
      <div *ngFor="let column of columns; let i = index;" class="locationColumn">
        <div>{{column?.name}} <i class="fa fa-close" (click)="removeColumn(i)"></i></div>
      </div>

      <!-- Reload Button -->
      <button class="btn btn-rbv m-l-10" type="button" (click)="reloadTable()">
        <i class="fa fa-refresh"></i>
        Reload
      </button>
    </div>

    <div class="actual-data" [innerHTML]="text | safeHtml"></div>
  </div>

  <!-- Edit mode -->
  <div *ngIf="isEditMode">
    <angular-editor id="editableText" [(ngModel)]="text" [config]="editorConfig"
      (keyup.esc)="changeToEditMode()"></angular-editor>
    <!-- <quill-editor name="Editable_Text" [(ngModel)]="text"
      [modules]="quillModules" (keyup.esc)="changeToEditMode()"></quill-editor> -->
  </div>
</div>
